Apt.fn.extend('account-post', {}, {
	/**
	 * Bind actions for the review step
	 */
	reviewSetup() {
		const scope = this;

		scope.detailDrop();
		scope.mediaDrop();

		scope.initPlans();
	},

	/**
	 * Initialize submission
	 */
	initSubmit() {
		const scope = this;

		$.events.on('$postSubmit', 'click', () => {
			if (scope.currentStep !== 'review' && ! scope.validate()) {
				return;
			}

			LS.common.transition();

			$(window).on('beforeunload', e => {
				return e.returnValue = 'Still processing — discard listing?';
			}, {
				namespace: 'post'
			});

			LS.util.top();

			const data = scope.$form.serialize(true);
			const id = scope.id;

			scope.transform(data);

			LS.api.request('me/listings' + (id ? '/' + id : ''), {
				auth: true,
				method: id ?
					'patch' : 'post',
				data: data,
				flash: false,
				namespace: 'post',
				success: data => {
					scope.id = data.id;
					scope.message = data.message;

					$.app.post.$set('data.id', scope.id);

					scope.assets = 0;
					scope.uploads = {};

					if (data.attachments) {
						scope.assets += Object.keys(data.attachments).length;
					}

					if (data.images) {
						scope.assets += Object.keys(data.images).length;
					}

					if (! scope.assets) {
						scope.completeSubmit();

						return;
					}

					LS.util.flash('Uploading assets — please wait', null, {
						timeout: 600000
					});

					$.app.post.$set('processing', true);

					if (data.attachments) {
						scope.uploadAssets('attachments', data.attachments);
					}

					if (data.images) {
						scope.uploadAssets('images', data.images);
					}

					if (id) {
						LS.api.get(`listings/${id}/purge`, {
							flash: false,
							proxy: true
						});
					}
				},
				error: (xhr, conf, message) => {
					LS.common.transition(true);

					LS.util.warn(message);

					$(window).off('beforeunload.post');

					if (xhr.status !== 422) {
						LS.log.issue('PostError', xhr.responseText, {
							status: xhr.status
						});
					}
				}
			});
		}, {
			delegate: '$post',
			namespace: 'post'
		});
	},

	/**
	 * Transform data
	 *
	 * @param {Object} data
	 */
	transform(data) {
		if (this.syndicated) {
			delete data.images;
		}

		for (const [key, value] of Object.entries(data)) {
			const parts = key.split('[');

			if (parts.length > 1) {
				data[parts[0]] = data[parts[0]] || [];

				data[parts[0]].push(value);

				delete data[key];
			}
		}

		if (data.auction) {
			if (data.auction.begins_at_date) {
				data.auction.begins_at = data.auction.begins_at_date + 'T' + data.auction.begins_at_time;
			}

			delete data.auction.begins_at_date;
			delete data.auction.begins_at_time;

			if (data.auction.ends_at_date) {
				data.auction.ends_at = data.auction.ends_at_date + 'T' + data.auction.ends_at_time;
			}

			delete data.auction.ends_at_date;
			delete data.auction.ends_at_time;
		}
	},

	/**
	 * Upload assets
	 *
	 * @param {String} type
	 * @param {Object} files
	 */
	uploadAssets(type, files) {
		const scope = this;
		const keys = Object.keys(files);

		scope.uploads[type] = {
			active: 1,
			count: keys.length,
			keys: keys,
			uploaded: []
		};

		scope.queue(type, files);
	},

	/**
	 * Queue uploads
	 *
	 * @param {String} type
	 * @param {Object} files
	 */
	queue(type, files) {
		const scope = this;
		const group = scope.uploads[type];

		while (group.keys.length && group.active < 6) {
			scope.upload(type, files, group.keys.shift());
		}
	},

	/**
	 * Upload asset
	 *
	 * @param {String} type
	 * @param {Object} files
	 * @param {String} key
	 */
	upload(type, files, key) {
		const scope = this;
		const lookup = {
			[`data.${type}.key`]: key
		};

		let entry;

		scope.active++;

		entry = $.app.post.$get(['*', lookup]);

		$.fetch.request({
			url: files[key].url,
			method: 'put',
			data: entry.file,
			processData: false,
			namespace: 'post',
			headers: {
				'Content-Type': entry.type
			},
			success: () => {
				scope.uploads[type].uploaded.push(files[key].id);
			},
			complete: () => {
				scope.uploads[type].count--;
				scope.uploads[type].active--;

				scope.assets--;

				if (scope.uploads[type].count) {
					scope.queue(type, files);

					return;
				}

				LS.api.request(`me/listings/${scope.id}/${type}`, {
					auth: true,
					method: 'patch',
					data: {
						id: scope.uploads[type].uploaded
					},
					flash: false,
					namespace: 'post',
					complete: () => {
						if (! scope.assets) {
							scope.completeSubmit();
						}
					}
				});
			}
		});
	},

	/**
	 * Complete submission
	 */
	completeSubmit() {
		const scope = this;

		scope.setStep(7);

		LS.common.transition(true);

		LS.util.flash(scope.message, 'success');

		$(window).off('beforeunload.post');
	},

	/**
	 * Initialize plans
	 */
	initPlans() {
		$.events.on('$postPlan', 'click', (e, el) => {
			$.app.post.$set('plan', el.dataset.value);
		}, {
			delegate: this.$form,
			namespace: 'post'
		});
	}
});